import { defineStore } from 'pinia'
import { ref } from 'vue'

const API_ROOT_URL = import.meta.env.VITE_HASMCP_ACCOUNTS_API_ROOT_URL;
const CONFIG_CACHE_KEY = 'hasmcp_configurations'
const CONFIG_TTL_MS = 30 * 60 * 1000 // 30 Minutes

export const useConfigStore = defineStore('config', () => {
  const configurations = ref(null)

  const saveToCache = (data) => {
    const payload = { value: data, expires: Date.now() + CONFIG_TTL_MS }
    localStorage.setItem(CONFIG_CACHE_KEY, JSON.stringify(payload))
  }

  const loadFromCache = () => {
    const itemStr = localStorage.getItem(CONFIG_CACHE_KEY)
    if (!itemStr) return null
    try {
      const item = JSON.parse(itemStr)
      if (Date.now() > item.expires) {
        localStorage.removeItem(CONFIG_CACHE_KEY)
        return null
      }
      return item.value
    } catch (e) {
      localStorage.removeItem(CONFIG_CACHE_KEY)
      return null
    }
  }

  const fetchConfigurations = async () => {
    // 1. Check in-memory state first
    if (configurations.value) return configurations.value

    // 2. Check localStorage cache
    const cached = loadFromCache()
    if (cached) {
      configurations.value = cached
      return cached
    }

    // 3. Fetch from API if cache is missing/expired
    try {
      const response = await fetch(`${API_ROOT_URL}/configurations`)
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

      const data = await response.json()
      const configData = data.configurations || data

      configurations.value = configData
      saveToCache(configData)
      return configData
    } catch (error) {
      console.error("Failed to fetch configurations:", error)
      throw error
    }
  }

  return {
    configurations,
    fetchConfigurations
  }
})